import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("org/preferences/rostering_method_preference.scss");





//////////////////// PARTIALLY ABLE TO SUPPORT MULTI ORG ACCOUNTS !!!!!!

@connect(
	(state, props) => {
		var selectedSchoolOrgs = []
		var selectedDistrictOrgs = []
		var admin = RosterSelectors.admin({state, id:CurrentUser.get().id})
		var refPrefs = {}

		if (admin.org_ids.school_orgs && admin.org_ids.school_orgs.all) {
			var selectedSchoolOrgs = RosterSelectors.schoolOrgs({
				state, conditions: { ids: admin.org_ids.school_orgs.all }
			})
			if (selectedSchoolOrgs.length > 0) {
				refPrefs = selectedSchoolOrgs[0].prefs 
			}
		}
		if (admin.org_ids.district_orgs && admin.org_ids.district_orgs.all) {
			var selectedDistrictOrgs = RosterSelectors.districtOrgs({
				state, conditions: { ids: admin.org_ids.district_orgs.all }
			})
			if (selectedDistrictOrgs.length > 0) {
				refPrefs = selectedDistrictOrgs[0].prefs 
			}
		}

		return {
			admin,
			selectedSchoolOrgs,
			selectedDistrictOrgs,
			refPrefs,
			prefs: {}
		}
	},

	 (dispatch, props)=>({

        populateData: () => {
            //STEP 1: Grab logged in admin
            return Promise.all([ dispatch(RosterActions.fetchAdmins({
                filters:{ids: [CurrentUser.get().id]}, 
                embeds:['admin.org_ids'],
                cache: false
            })).then(response=>{
            	var currentAdmin = response.admins[0]
            	if (currentAdmin) {
            		if (CurrentUser.isSchoolAdmin()) {
	            		if (currentAdmin.org_ids.school_orgs && currentAdmin.org_ids.school_orgs.all.length > 0) {
	            			// LOAD SCHOOL ORGS
	            			return Promise.all([ dispatch(RosterActions.fetchSchoolOrgs({
				                filters:{ids: currentAdmin.org_ids.school_orgs.all}, 
				                embeds:['school_org.prefs,school_org.district_org,district_org.prefs'],
				                cache: false
				            }))])
	            		}
	            	} else {
	            		if (currentAdmin.org_ids.district_orgs && currentAdmin.org_ids.district_orgs.all.length > 0) {
	            			// LOAD DISTRICT ORGS
	            			return Promise.all([ dispatch(RosterActions.fetchDistrictOrgs({
				                filters:{ids: currentAdmin.org_ids.district_orgs.all}, 
				                embeds:['district_org.prefs,district_org.clever_access_tokens'],
				                cache: false
				            }))])
	            		}
	            	}
            	}
            })])
        },
        onDistrictPrefChange: (districtOrgID, prefsUpdate) => {
        	window.wrNotifications.triggerDropDownNotification({
				title: "Rostering method saved", text: "Your district preferences were updated", icon: "ok-sign"
			});
			return dispatch(RosterActions.updateDistrictOrgPrefs({
				currentUserID: CurrentUser.get().id,
				districtOrgID,
				resetPrefs: true,
				update: {"rostering_method": prefsUpdate}
			}), window.location.reload())
		},
		onSchoolPrefChange: (schoolOrgID, prefsUpdate) => {
			window.wrNotifications.triggerDropDownNotification({
				title: "Rostering method saved", text: "Your school preferences were updated", icon: "ok-sign"
			});
			return dispatch(RosterActions.updateSchoolOrgPrefs({
				currentUserID: CurrentUser.get().id,
				schoolOrgID,
				resetPrefs: true,
				update: {"rostering_method": prefsUpdate}
			}), window.location.reload())
		}
    })
)

@providePopulateData({waitForLoad:true})
class RosteringMethodPreference extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("RosteringMethodPreference");

		// DEFINE DEFAULT PREFS
		if (CurrentUser.isDistrictAdmin()) {
			var selectedManager = DISTRICT_MANAGER
		} else {
			var selectedManager = SCHOOL_MANAGER
		}	
		var selectedMethod = CLEVER_METHOD

		if (props.refPrefs && props.refPrefs.rostering_method) {
			selectedMethod = props.refPrefs.rostering_method.method
			selectedManager = props.refPrefs.rostering_method.manager
		}

		this.state = {selectedManager, selectedMethod}
	}

	getInitialSelectedManager() {
		if (CurrentUser.isDistrictAdmin()) {
			return DISTRICT_MANAGER
		} else {
			return SCHOOL_MANAGER
		}
	}

	selectOwnedOrgs(orgs, field) {
		return _.select(orgs, (org) => this.props.admin.org_ids[field]["all"].includes(org.id))
	}

	getOrgLabel() {
		if (CurrentUser.isSchoolAdmin()) {
			return "School"
		} else {
			return "District"
		}
	}

	updateManager(selectedManager) {
		if (selectedManager != this.state.selectedMethod) {
			this.setState({selectedManager})
		}
	}

	updateMethod(selectedMethod) {
		if (selectedMethod != this.state.selectedMethod) {
			this.setState({selectedMethod})
		}
	}

	renderRosteringManagerOption() {

		if (CurrentUser.isDistrictAdmin()) {
			return (
				<div className="section">
					<b>Who will be in charge of rostering students?</b>
					<div > 
						<label>
							<input type="radio" onChange={ this.updateManager.bind(this, DISTRICT_MANAGER) } checked={ this.state.selectedManager == DISTRICT_MANAGER ? true : false } /> 
							Rostering will be managed at the district level
						</label>
					</div>
					<div > 
						<label>
							<input type="radio" onChange={ this.updateManager.bind(this, SCHOOL_MANAGER) } checked={ this.state.selectedManager == SCHOOL_MANAGER ? true : false } /> 
							Rostering will be managed by each school admin
						</label>
					</div>
					<div > 
						<label>
							<input type="radio" onChange={ this.updateManager.bind(this, INDIVIDUAL_MANAGER) } checked={ this.state.selectedManager == INDIVIDUAL_MANAGER ? true : false } /> 
							Rostering will be managed by individual teachers
						</label>
					</div>
				</div>
			)
		} else {
			const disabled = this.isPrefsDisabled()
			return (
				<div className="section">
					<b>Who will be in charge of rostering students?</b>
					<div > 
						<label>
							<input type="radio" onChange={ this.updateManager.bind(this, SCHOOL_MANAGER) } checked={ this.state.selectedManager == SCHOOL_MANAGER ? true : false } disabled={disabled} /> 
							Rostering will be managed at the school level
						</label>
					</div>
					<div > 
						<label>
							<input type="radio" onChange={ this.updateManager.bind(this, INDIVIDUAL_MANAGER) } checked={ this.state.selectedManager == INDIVIDUAL_MANAGER ? true : false } disabled={disabled} /> 
							Rostering will be managed by individual teachers
						</label>
					</div>
				</div>
			)
		}
	}

	renderUploadMethod() {
		const disabled = this.isPrefsDisabled()

		if (this.state.selectedManager == INDIVIDUAL_MANAGER) {
			return (
				<div className="section"> 
					<b>Which rostering method should all teachers use?</b>
					<div> 
						<label>
							<input disabled={disabled} type="radio" onChange={ this.updateMethod.bind(this, CLEVER_METHOD) } checked={ this.state.selectedMethod == CLEVER_METHOD ? true : false } /> 
							Clever SSO (recommended)
						</label>
					</div>
					<div> 
						<label>
							<input disabled={disabled} type="radio" onChange={ this.updateMethod.bind(this, GOOGLE_METHOD) } checked={ this.state.selectedMethod == GOOGLE_METHOD ? true : false } /> 
							Google SSO (recommended)
						</label>
					</div>
					<div> 
						<label>
							<input disabled={disabled} type="radio" onChange={ this.updateMethod.bind(this, MANUAL_METHOD) } checked={ this.state.selectedMethod == MANUAL_METHOD ? true : false } /> 
							Excel, CSV file upload, copy-paste or class codes
						</label>
					</div>
				</div>
			)
		} else {

			// IF DISTRICT ADMIN DELEGATES TO SCHOOL ADMIN
			if (this.state.selectedManager == SCHOOL_MANAGER && CurrentUser.isDistrictAdmin()) {
				return (
					<div className="section"> 
						<b>School admins will choose the rostering method for each school</b>
					</div>
				)
			} else {
				return (
					<div className="section"> 
						<b>Which rostering method do you wish to use?</b>
						<div> 
							<label>
								<input disabled={disabled} type="radio" onChange={ this.updateMethod.bind(this, CLEVER_METHOD) } checked={ this.state.selectedMethod == CLEVER_METHOD ? true : false } /> 
								Clever SSO (recommended)
							</label>
						</div>
						<div> 
							<label>
								<input disabled={disabled} type="radio" onChange={ this.updateMethod.bind(this, MANUAL_METHOD) } checked={ this.state.selectedMethod == MANUAL_METHOD ? true : false } /> 
								Excel, CSV file upload, copy-paste or class codes
							</label>
						</div>
					</div>
				)
			}
		}
	}

	renderOrgCleverExplanation(org) {
		if (org.clever_access_tokens && org.clever_access_tokens.length > 0) {
			var lastToken = org.clever_access_tokens.sort((a,b) => b.id-a.id)[0]
			if (lastToken.synced_at) {
				const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

				let date = new Date(lastToken.synced_at);
				return (
					<div>
						You have successfully shared your Clever rostering information.
						<br/>
						Last Synced: {date.toLocaleDateString(undefined, options)}
					</div>
				)
			}
		}
		return (
			<div>
				We have not received your Clever rostering data yet.
				<br/>
			</div>
		)
	}

	renderOrgCsvExplanation() {
		return (
			<div>
				We have not received your rostering data yet.
				<br/>
			</div>
		)
	}

	renderIndividualCleverExplanation() {
		return (
			<div>
				Note: Teachers will only be able to add students using Clever. This consistency prevents rostering issues.
			</div>
		)
	}

	renderIndividualGoogleExplanation() {
		return (
			<div>
				Note: Teachers will only be able to add students using Google Classroom. This consistency prevents rostering issues.
			</div>
		)
	}

	renderIndividualManualExplanation() {
		return (
			<div>
				Note: Teachers will only be able to add students using manual methods. This consistency prevents rostering issues.
			</div>
		)
	}

	renderDistrictDelegatingToSchoolAdminExplanation() {
		return (
			<div>
				We have not received a list of school admins yet.
				<br/>
			</div>
		)
	}

	renderMethodExplanation(org) {
		if (this.state.selectedManager == DISTRICT_MANAGER || this.state.selectedManager == SCHOOL_MANAGER) {
			// DISTRICT ADMIN DELEGATES TO SCHOOL ADMIN
			if (CurrentUser.isDistrictAdmin() && this.state.selectedManager == SCHOOL_MANAGER) {
				var content = this.renderDistrictDelegatingToSchoolAdminExplanation()
			} else if (this.state.selectedMethod == CLEVER_METHOD) {
				var content = this.renderOrgCleverExplanation(org)
			} else if (this.state.selectedMethod == MANUAL_METHOD) {
				var content = this.renderOrgCsvExplanation()
			}
		} else {
			if (this.state.selectedMethod == CLEVER_METHOD) {
				var content = this.renderIndividualCleverExplanation()
			} else if (this.state.selectedMethod == GOOGLE_METHOD) {
				var content = this.renderIndividualGoogleExplanation()
			} else {
				var content = this.renderIndividualManualExplanation()
			}
		}
		
		return (
			<div className="section">
				{ content }
			</div>
		)
	}

	shouldSave() {
		if (this.isPrefsDisabled() || (this.props.refPrefs.rostering_method["method"] == this.state.selectedMethod && this.props.refPrefs.rostering_method["manager"] == this.state.selectedManager)) {
			return false
		}
		return true
	}

	getUpdatedPrefs() {
		return {"method": this.state.selectedMethod, "manager": this.state.selectedManager}
	}

	renderSchoolOrgPrefs() {
		var ownedOrgs = this.selectOwnedOrgs(this.props.selectedSchoolOrgs, "school_orgs") 
		var sections =_.map(ownedOrgs, (school, s) => {
			
			if (!this.isPrefsDisabled()) {

				var updateButton = (
					<button className="btn btn-primary saveAction" onClick={this.onSaveSchoolPrefs.bind(this, school.id)}>
						Save changes
					</button>
				)
			}

			if (!this.isPrefsDisabled()) {
				var explanation = this.renderMethodExplanation(school)
			}

			return (
				<div index={s}>
					<h2>{school.name}</h2>
					{ this.renderEditWarning() }
					{ this.renderRosteringManagerOption() }
					{ this.renderUploadMethod() }
					{ explanation }
					{ updateButton }
				</div>
			)
		})

		return (
			<div className="org-section">
				{ sections }
			</div>
		)
	}

	onSaveDistrictPrefs(districtOrgID) {
		var prefs = this.getUpdatedPrefs()

		if (prefs["manager"] == SCHOOL_MANAGER) {
			prefs["method"] = CLEVER_METHOD
		}

		this.props.onDistrictPrefChange(districtOrgID, prefs)
	}

	onSaveSchoolPrefs(schoolOrgID) {
		var prefs = this.getUpdatedPrefs()
		this.props.onSchoolPrefChange(schoolOrgID, prefs)
	}

	isPrefsDisabled() {
		if (CurrentUser.isSchoolAdmin()) {
			console.log("IS A SCHOOL ADMIN")

			var schoolOrg = this.selectOwnedOrgs(this.props.selectedSchoolOrgs, "school_orgs")
			console.log(schoolOrg)

			if (schoolOrg && schoolOrg.length > 0) {
				console.log("WE GOT SCHOOL ORGS")
				schoolOrg = schoolOrg[0]
				if (schoolOrg.district_org && schoolOrg.district_org.prefs && schoolOrg.district_org.prefs["rostering_method"]) {
					console.log("SCHOOL ORG HAS PREFS")
					const pref = schoolOrg.district_org.prefs["rostering_method"]
					console.log(pref)
					if (pref["manager"] == "individual" || pref["manager"] == "district_org") {
						return true
					}
				}
			}
		}
		return false
	}

	renderEditWarning() {
		if (this.isPrefsDisabled()) {
			return (
				<p>
					Rostering settings were set by your district admnistrator
				</p>
			)
		}
		return ""
	}

	renderDistrictPrefs() {
		var ownedOrgs = this.selectOwnedOrgs(this.props.selectedDistrictOrgs, "district_orgs") 
		var sections =_.map(ownedOrgs, (district, s) => {
			if (!this.isPrefsDisabled()) {
				var updateButton = (
					<button className="btn btn-primary saveAction" onClick={this.onSaveDistrictPrefs.bind(this, district.id)}>
						Save changes
					</button>
				)
			}

			return (
				<div index={s}>
					<h2>{district.name}</h2>
					{ this.renderRosteringManagerOption() }
					{ this.renderUploadMethod() }
					{ this.renderMethodExplanation(district) }
					{ updateButton }
				</div>
			)
		})

		return (
			<div className="org-section">
				{ sections }
			</div>
		)
	}

	render() {

		return (
			<div className="RosteringMethodPreference">
				{ this.renderSchoolOrgPrefs() }
				{ this.renderDistrictPrefs() }
			</div>
		)
	}
}

var DISTRICT_MANAGER = "district_org"
var SCHOOL_MANAGER = "school_org"
var INDIVIDUAL_MANAGER = "individual"
var CLEVER_METHOD = "clever"
var GOOGLE_METHOD = "google"
var MANUAL_METHOD = "manual"

RosteringMethodPreference.WrappedComponent.propTypes = StrictPropTypes({
	// Handlers from @connect
	admin: PropTypes.object,
	selectedSchoolOrgs: PropTypes.array,
	selectedDistrictOrgs: PropTypes.array,
	prefs: PropTypes.object,
	populateData: PropTypes.func.isRequired,
	// onChange: PropTypes.func.isRequired,
});

module.exports = RosteringMethodPreference;



// WEBPACK FOOTER //
// ./modules/components/org/preferences/RosteringMethodPreference.js